import { useGmbChecklist } from '../../hooks/useGmbImplementation';

interface QAAndChecklistProps {
  onTooltipShow: (title: string, content: string) => void;
}

export default function QAAndChecklist({ onTooltipShow }: QAAndChecklistProps) {
  const { data: checklistData, isLoading: checklistLoading } = useGmbChecklist();

  const checklist = checklistData?.data?.checklist || [];
  const totalTasks = checklistData?.data?.total_tasks || 0;
  const completedTasks = checklistData?.data?.completed_tasks || 0;

  return (
    <div className="space-y-8 relative">
      {/* Q&A Manager */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200">Q&A Manager</h3>
          <button
            onClick={() => onTooltipShow('Q&A Management', 'Google discontinued the My Business Q&A API on November 3, 2025. This feature is no longer available through Google and cannot be restored.')}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            title="More info"
          >
            <i className="ri-information-line text-lg"></i>
          </button>
        </div>

        <div className="bg-gray-50 dark:bg-gray-800/60 border border-gray-200 dark:border-gray-700 rounded-lg p-8 text-center">
          <i className="ri-time-line text-4xl text-gray-300 dark:text-gray-600 mb-3 block"></i>
          <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">Coming Soon</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 max-w-md mx-auto">
            Google discontinued the My Business Q&A API. This feature is currently unavailable and will return if Google reintroduces the API.
          </p>
        </div>
      </div>

      {/* Implementation Progress Checklist */}
      {checklistLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2].map(i => (
            <div key={i} className="rounded-xl border border-gray-200 dark:border-gray-700 p-5 animate-pulse">
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-48 mb-3"></div>
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full mb-2"></div>
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
            </div>
          ))}
        </div>
      ) : checklist.length > 0 && (
        <div>
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200">Implementation Progress</h3>
            <span className="text-xs text-gray-400 dark:text-gray-500">{completedTasks}/{totalTasks} tasks</span>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
            <div className="w-full h-2 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden mb-4">
              <div
                className="h-full bg-teal-500 rounded-full transition-all"
                style={{ width: `${totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0}%` }}
              />
            </div>
            <div className="space-y-4">
              {checklist.map((cat: any) => (
                <div key={cat.name}>
                  <h4 className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2">{cat.name}</h4>
                  <div className="space-y-1">
                    {cat.items.map((item: any) => (
                      <div key={item.label} className="flex items-center gap-2 text-xs">
                        <i
                          className={`${
                            item.status === 'done' ? 'ri-checkbox-circle-fill text-green-500' : 'ri-close-circle-fill text-red-500'
                          } text-sm`}
                        ></i>
                        <span className="text-gray-700 dark:text-gray-300">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
